import {
  CleanUpStrategyType,
  ExternallyManagedNoCleanupStrategy,
  LimitedLifetimeCleanUpStrategy
} from "client/resources/cleanUpStrategy";
import React from "react";
import {
  DataTableRow,
  DataTableRowColumn,
  DataTableRowHeaderColumn,
  DataTableRowWithActionColumn
} from "../../../components/DataTable";
import {FriendlyLocalTime} from "../../../shared/FriendlyLocalTime";
import moment from "moment/moment";
import {Errors} from "../../../components/DataBaseComponent";
import {BusyState} from "../../../components/BusyFromPromise/BusyFromPromise";
import {DoBusyTask} from "../../../components/DataBaseComponent/DataBaseComponent";
import {HostedInstanceResource} from "../../../client/resources/hostedInstanceResource";
import OpenDialogButton from "~/components/Dialog/OpenDialogButton";
import ChangeCleanUpStrategyDialog from "~/areas/instances/Instances/ChangeCleanUpStrategyDialog";

interface CleanUpStrategyRowsProps { 
  instance: HostedInstanceResource;
  setInstance: (instance: HostedInstanceResource) => void; 
  errors: Errors; 
  busy: BusyState; 
  doBusyTask: DoBusyTask; 
}


function TrialCleanUpStrategy(props: CleanUpStrategyRowsProps & {cleanUpStrategy: LimitedLifetimeCleanUpStrategy}) {
  return (<>
    <DataTableRow>
      <DataTableRowHeaderColumn>Created</DataTableRowHeaderColumn>
      <DataTableRowColumn><FriendlyLocalTime time={moment.utc(props.cleanUpStrategy.CreatedOn).local().toString()}/></DataTableRowColumn>
    </DataTableRow>
    <DataTableRow>
      <DataTableRowHeaderColumn>Deactivation</DataTableRowHeaderColumn>
      <DataTableRowWithActionColumn action={
        <OpenDialogButton label="Change Clean Up Strategy">
          {ChangeCleanUpStrategyDialog(props)}
        </OpenDialogButton>
      }>
        <FriendlyLocalTime time={moment.utc(props.cleanUpStrategy.DeactivationDate).local().toString()}/>
      </DataTableRowWithActionColumn>
    </DataTableRow>
    <DataTableRow>
      <DataTableRowHeaderColumn>Deletion</DataTableRowHeaderColumn>
      <DataTableRowColumn><FriendlyLocalTime time={moment.utc(props.cleanUpStrategy.DeletionDate).local().toString()}/></DataTableRowColumn>
    </DataTableRow>
  </>);
}

function ExternallyManagedCleanUpStrategy(noCleanupStrategy: ExternallyManagedNoCleanupStrategy) {
  return null as JSX.Element;
}

function NeverCleanUpStrategy(props: { CleanUpStrategyType: CleanUpStrategyType.NeverCleanUpStrategy, CreatedOn: string }) {
  return (<>
    <DataTableRow>
      <DataTableRowHeaderColumn>Created</DataTableRowHeaderColumn>
      <DataTableRowColumn><FriendlyLocalTime time={moment.utc(props.CreatedOn).local().toString()}/></DataTableRowColumn>
    </DataTableRow>
    <DataTableRow>
      <DataTableRowHeaderColumn>Deactivation</DataTableRowHeaderColumn>
      <DataTableRowColumn>Never</DataTableRowColumn>

    </DataTableRow>
    <DataTableRow>
      <DataTableRowHeaderColumn>Deletion</DataTableRowHeaderColumn>
      <DataTableRowColumn>Never</DataTableRowColumn>
    </DataTableRow>
  </>);
}

export function CleanUpStrategyRows(props: CleanUpStrategyRowsProps) {
  switch (props.instance.CleanUpStrategy.CleanUpStrategyType) {
    case CleanUpStrategyType.LimitedLifetimeCleanUpStrategy:
      return <TrialCleanUpStrategy {...props} cleanUpStrategy={props.instance.CleanUpStrategy} />
    case CleanUpStrategyType.ExternallyManagedNoCleanupStrategy:
      return <ExternallyManagedCleanUpStrategy {...props.instance.CleanUpStrategy} />
    case CleanUpStrategyType.NeverCleanUpStrategy:
      return <NeverCleanUpStrategy {...props.instance.CleanUpStrategy} />
    default:
      const _exhaustiveCheck: never = props.instance.CleanUpStrategy;
  }
}
